import React from 'react';
import clsx from 'clsx';
import { useTranslate } from 'react-admin';
import { Grid } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  errorContainer: {
    display: "none",
    flexDirection: "column",
    alignItems: "center",
    color: '#721c24',
    backgroundColor: '#f8d7da',
    borderColor: '#f5c6cb',
    padding: '.85rem 1.25rem',
    borderRadius: '.25rem',
    width: '50%',
    margin:'200px auto',
  },
  span: {
    display:'none !important'
  }
}));

export function ErrorLoginPageForm () {

  const classes  = useStyles();
  const translate = useTranslate();

  return(
    <Grid container className={clsx(classes.errorContainer, 'errorContainer')}>
      <Grid item className={clsx(classes.errorMessage, 'errorMessage')}>
        {translate('errors.domain')}
      </Grid>
    </Grid>
  );
}